import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { InputGroup, Input, Row, Col, Form, Button, FormGroup } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import validate from './validation';
import { ConfirmCode, resendCode ,SendingEmail} from '../../../../redux/Action/fogoetpassword';

const renderField = ({ onChange, value, input, label, type, meta: { touched, error, warning } }) => (
    <div>
        <InputGroup>
            <Input {...input} placeholder="12345" type={type} value={value} onChange={onChange} maxlength="5" />
        </InputGroup >
        <div>
            {touched && ((error && <span className="erroMSG" > {error}</span>))}
        </div>
    </div>
)

class ConfirmationCode extends Component {

    state = { inputValue: '' }

    onSubmit = (values) => {
        // this.props.showLoading();
        values.email = localStorage.getItem('email');
        values.type =this.props.type;
        console.log("email",values)
        this.props.ConfirmCode(values);
    }

    render() {
        const { handleSubmit, submitting } = this.props;
        return (
            <div>
               
                <Row>
                    <Col lg="12">
                        <h2 className="mb-3">الكود</h2>
                    </Col>
                    <Col lg="10" className="m-auto">
                        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            <FormGroup>
                                <Field type="text" name="code" component={renderField}
                                    value={this.state.inputValue}
                                    onChange={e => {
                                        let inputValue = e.target.value;
                                        inputValue = inputValue.replace(/[^0-9]/, "");
                                        this.setState({ inputValue });
                                    }} />
                            </FormGroup>
                            <div className="ConfirmCode-resendCode">
                                <p onClick={() => this.props.SendingEmail({type:"ADMIN", email:localStorage.getItem('email')})}>اعادة ارسال الكود</p>
                            </div>
                            <div className="pb-4 pt-2">
                                <Button disabled={submitting}>تاكيد</Button>
                            </div>
                        </Form>
                    </Col>
                </Row>

            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        ConfirmCode,
        resendCode,
        SendingEmail
        
    }
    , dispatch
)

export default reduxForm({
    form: 'fieldLevelValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(ConfirmationCode));